__turbopack_context__.v({
  "box": "form-box-module-scss-module__8hlawq__box",
  "box-wide": "form-box-module-scss-module__8hlawq__box-wide",
  "fieldset": "form-box-module-scss-module__8hlawq__fieldset",
  "placeholder": "form-box-module-scss-module__8hlawq__placeholder",
  "row": "form-box-module-scss-module__8hlawq__row",
  "row-columns-1fr": "form-box-module-scss-module__8hlawq__row-columns-1fr",
  "row-columns-1fr-1fr": "form-box-module-scss-module__8hlawq__row-columns-1fr-1fr",
  "row-columns-1fr-2fr": "form-box-module-scss-module__8hlawq__row-columns-1fr-2fr",
  "row-columns-2fr-1fr": "form-box-module-scss-module__8hlawq__row-columns-2fr-1fr",
});
